<app-data-table-container class="max-h-[calc(52px*5)] border border-gray-200">
  <table mat-table [dataSource]="dataSource()">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Naam</th>
      <td mat-cell *matCellDef="let element">
        <div class="flex items-center gap-2">
          @let isPlayingAudio = isPlaying() && element.linkId === currentTrackId();
          <button
            mat-icon-button
            (click)="handleAudioPlayback(element)"
            class="[--mdc-icon-button-state-layer-size:32px] bg-gray-100!"
          >
            <mat-icon>{{ isPlayingAudio ? 'stop' : 'play_arrow' }}</mat-icon>
          </button>

          <span
            class="w-min max-w-40 truncate block"
            [matTooltip]="element.label"
            matTooltipPosition="after"
            >{{ element.label }}</span
          >
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="duration">
      <th mat-header-cell *matHeaderCellDef>Duratie</th>
      <td mat-cell *matCellDef="let element">
        @if (element.metadata.duration; as duration) {
          {{ duration | secondsToDuration }}
        } @else {
          -
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="size">
      <th mat-header-cell *matHeaderCellDef>Grootte</th>
      <td mat-cell *matCellDef="let element">
        @if (element.metadata.size; as size) {
          {{ size | filesize }}
        } @else {
          -
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        @if (!hideActions()) {
          <button mat-icon-button (click)="handleItemRemove(element.linkId)">
            <mat-icon>delete</mat-icon>
          </button>
        }
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayedColumns; sticky: true"
      class="whitespace-nowrap"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="hover:!bg-gray-100 whitespace-nowrap"
    ></tr>

    <tr class="mat-mdc-row" *matNoDataRow>
      <td
        class="mat-mdc-cell mdc-data-table__cell !border-none"
        [colSpan]="displayedColumns.length"
      >
        Geen resultaten gevonden
      </td>
    </tr>
  </table>
</app-data-table-container>
